module.exports = __webpack_public_path__ + "img/produit-favoris-empty.5534de74.svg";